/* eslint-disable camelcase */
import React from 'react';
import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 12,
    color: '#1e3f9e',
    maxWidth: 650,
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
  },
  textBox: {
    marginRight: '2em',
  },
  button: {
    marginLeft: '2em',
    marginBottom: '2em',
    display: 'flex',
  },
}));

const MacAddress = ({ macAddress, setMacAddress }) => {
  const classes = useStyles();
  return (
    <div>
      <h4 className={classes.title}>Enter the 6-character alphanumeric identifier (ID) found on the monitor:</h4>
      <div className={classes.container}>
        <TextField
          className={classes.textBox}
          size="small"
          placeholder="Monitor ID"
          label="Monitor ID"
          value={macAddress}
          onChange={(event) => setMacAddress(event.target.value.toUpperCase())}
        />
      </div>
    </div>
  );
};

MacAddress.propTypes = {
  setMacAddress: PropTypes.func,
  macAddress: PropTypes.string,
};

MacAddress.defaultProps = {
  setMacAddress: null,
  macAddress: '',
};

export default MacAddress;
